import React from 'react';
import Api from "../../components/helpers/Api";
import {Button, Row, Spinner} from "reactstrap";
import {RiDeleteBin6Line} from "@remixicon/react";
import {RiAddLine, RiEyeFill} from "react-icons/ri";
import withNavigationHook from "../../hooks/withNavigationHook";
import { debugLog } from "../../utils/debug";

class ScripturesDropdown extends React.Component {
    state = {
        isLoading: false,
        listItems: [],
        bookSelected: null,
        chapterOptionsFrom: [],
        verseOptionsFrom: [],
        chapterOptionsTo: [],
        verseOptionsTo: [],
        chosenPassageButtons: null,
        isChapterDisabled: true,
        isVerseDisabled: true
    }

    componentDidMount() {
        this.setState({isLoading: true});
        const customer = JSON.parse(sessionStorage.getItem("customer"));
        const userId = customer?.user?.id;

        if (userId && !sessionStorage.getItem("preferred-song-books")) {
            Api.get(`/user/${userId}/preferences/song-book`)
                .then(res => {
                    const preferred = res.data || [];
                    sessionStorage.setItem(
                        "preferred-song-books",
                        JSON.stringify(preferred)
                    );

                })
                .catch(err => {
                    console.error("Failed to load preferred song books", err);
                });
        }

        Api.get(`/scripture`)
            .then(res => {
                const listItems = res.data;
                sessionStorage.setItem("scripture", JSON.stringify(listItems));
                this.setState({listItems: listItems});
                this.setState({isLoading: false});
            })
            .catch(err => {
                console.error("Error loading scripture books:", err);
                this.setState({ isLoading: false });
            });

        const passages = sessionStorage.getItem("selected-passages") == null ? [] : JSON.parse(sessionStorage.getItem("selected-passages"));
        this.setState({
            chosenPassageButtons: passages
                .map((passage, index) => {
                return this.showPill(index, passage);
            })
        })

    }

    changeBookHandlerFrom = (event) => {
        if (event.target.value.toUpperCase().indexOf("BOOK")) { // i.e. not first option in list
            const book = this.state.listItems.filter(b => b.id === event.target.value)[0];
            this.setState({bookSelected: book});

            const newChapterOptions = [];
            for (let i = 0; i < book.chapterCount; i++) {
                newChapterOptions.push(<option key={i + 1}>{i + 1}</option>);
            }

            this.setState({chapterOptionsFrom: newChapterOptions});
            this.setState({chapterOptionsTo: newChapterOptions});


            this.setState({
                isChapterDisabled: false
            });
        } else {
            this.setState({chapterOptionsFrom: []});
            this.setState({chapterOptionsTo: []});
            this.setState({bookSelected: null});
            this.setState({chapterSelected: null});
            this.setState({verseOptionsFrom: []});
            this.setState({verseFromSelected: null});

            this.setState({
                isChapterDisabled: true,
                isVerseDisabled: true
            });
        }
    };

    changeChapterHandlerFrom = (event) => {
        if (event.target.value.toUpperCase().indexOf("CHAPTER")) { // i.e. not first option in list
            const chapterSelected = event.target.value;
            this.setState({chapterSelected: chapterSelected});

            const versesCount = this.state.listItems.filter(b => b.id === this.state.bookSelected.id)[0].versesCount[chapterSelected];
            const newVerseOptions = [];
            for (let i = 0; i < versesCount; i++) {
                newVerseOptions.push(<option key={i + 1}>{i + 1}</option>);
            }

            this.setState({verseOptionsFrom: newVerseOptions});
            this.setState({verseOptionsTo: newVerseOptions});

            this.setState({
                isVerseDisabled: false
            });
        } else {
            this.setState({verseOptionsFrom: []});
            this.setState({chapterSelected: null});
            this.setState({verseFromSelected: null});
            this.setState({verseToSelected: null});

            this.setState({
                isVerseDisabled: true
            });
        }
    };

    changeVerseHandlerFrom = (event) => {
        if (event.target.value.toUpperCase().indexOf("VERSE")) { // i.e. not first option in list
            const verseFromSelected = event.target.value;
            this.setState({verseFromSelected: verseFromSelected});
        } else {
            this.setState({verseFromSelected: null});
        }
    };

    changeVerseHandlerTo = (event) => {
        if (event.target.value.toUpperCase().indexOf("VERSE")) { // i.e. not first option in list
            const verseToSelected = event.target.value;
            this.setState({verseToSelected: verseToSelected});
        } else {
            this.setState({verseToSelected: null});
        }
    };

    addButtonAvailable = () => {
        return this.state.bookSelected != null && this.state.chapterSelected; // && this.state.verseFromSelected;
    }

    addPassageToList = () => {
        if (this.addButtonAvailable) {
            debugLog(
                "passage added: book: " + this.state.bookSelected.id +
                ", chapter: " + this.state.chapterSelected +
                ", verseFrom: " + this.state.verseFromSelected +
                ", verseTo: " + this.state.verseToSelected
            );
            const passages = sessionStorage.getItem("selected-passages") == null ? [] : JSON.parse(sessionStorage.getItem("selected-passages"));
            const passage = {
                bookId: this.state.bookSelected.id,
                book: this.state.bookSelected.title,
                chapter: this.state.chapterSelected,
                verseFrom: this.state.verseFromSelected,
                verseTo: this.state.verseToSelected
            };

            if (!passages.some(existing => existing.bookId === passage.bookId && existing.book === passage.book && existing.chapter === passage.chapter && existing.verseFrom === passage.verseFrom && existing.verseTo === passage.verseTo)) {
                passages.push(passage);

                sessionStorage.setItem("selected-passages", JSON.stringify(passages));

                this.setState({
                    chosenPassageButtons: passages
                        .sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1)
                        .map((passage, index) => {
                        return this.showPill(index, passage);
                    })
                })
    
                this.props.enableActiveButtonHandler(true);
                sessionStorage.setItem("scriptureContinueEnabled", true);
            }
        }
    }

    passageMatch = (p1, p2) => {
        return (p1.book === p2.book && p1.bookId === p2.bookId && p1.chapter === p2.chapter) &&
            ((!p1.verseFrom && !p2.verseFrom) || p1.verseFrom === p2.verseFrom) &&
            ((!p1.verseTo && !p2.verseTo) || p1.verseTo === p2.verseTo);
    }

    removePill = (passage) => {
        let updatedPassages = sessionStorage.getItem("selected-passages") == null ? null :
            JSON.parse(sessionStorage.getItem("selected-passages"))
                .filter(p => !this.passageMatch(passage, p));
        if (updatedPassages == null) {
            sessionStorage.removeItem("selected-passages");
        } else {
            sessionStorage.setItem("selected-passages", JSON.stringify(updatedPassages));
        }

        // this.componentDidMount();
        this.props.enableActiveButtonHandler(true);
    }

    showPill = (index, passage) => {
        const targetName = "NIV" +
            passage.book + "%20" + passage.chapter +
            (passage.verseFrom ? ":" + passage.verseFrom : "") +
            (passage.verseTo ? "-" + passage.verseTo : "");
        const passageLink = "https://www.biblegateway.com/passage/?" +
            "search=" + passage.book + "%20" + passage.chapter +
            (passage.verseFrom ? ":" + passage.verseFrom : "") +
            (passage.verseTo ? "-" + passage.verseTo : "") +
            "&version=NIV";
        const niceName = passage.book + " " + passage.chapter +
            (passage.verseFrom ? "v" + passage.verseFrom : "") +
            (passage.verseTo ? "-" + passage.verseTo : "");
        return (
            <div className="passage-pill">
                <Button className='text-uppercase mx-2 col-12' color="primary" size="sm" style={{margin: '4px', width: "95%"}} title={niceName}>
                    <span style={{fontSize:"0.6rem"}}>
                        {niceName}
                    </span>
                    &nbsp;
                    <a href="" title={"Remove " + niceName + " from selected passages"} onClick={() => this.removePill(passage)} className="btn-inner--icon ml-1 mr-1 float-right"><RiDeleteBin6Line size={16} color="white"/></a>
                    <a href={passageLink} title={"View " + niceName + " (opens in new window)"} className="btn-inner--icon ml-1 mr-1 float-right" target={targetName}><RiEyeFill size={16} color="white"/></a>&nbsp;
                </Button>
            </div>
        );
    }

    showSongBookPill = songBook => {
        return (
            <div className="passage-pill">
                <Button className='text-uppercase mx-2 col-12' color="primary" size="sm" style={{margin: '4px', width: "95%"}}>
                    <span className="text-white" style={{fontSize:"0.6rem"}}>
                        {songBook.title.length <= 22 ? songBook.title : !songBook.shortTitle ? songBook.title.substring(0,19) + "..." : songBook.shortTitle}
                    </span>
                    {/*&nbsp;&nbsp;<a a href={this.removeBook(songBook.id)}><RiDeleteBinLine color="white" size="16"/></a>*/}
                </Button>
            </div>
        );
    }

    getBookOptions() {
        return <>
            this.currentTestament = "";
            {
                this.state.listItems.map((listItem, index, array) => {
                    var optionGroup = "";
                    var option = <option key={listItem.id} className="dropdown-item" value={listItem.id}>{listItem.title}</option>;
                    if (index === 0 || this.currentTestament !== listItem.testamentTitle) {
                        this.currentTestament = listItem.testamentTitle;
                        optionGroup = <optgroup label={listItem.testamentTitle}>{listItem.testamentTitle}</optgroup>
                    }
                    return <React.Fragment>
                        {optionGroup}
                        {option}
                    </React.Fragment>
                })
            }
        </>;
    }

    render() {
        return (
            <div className="main-content-wrapper">
                {
                    this.state.isLoading ?
                        <div className="spinner-container">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                            &nbsp;Loading...
                        </div>
                    :
                        <div className="songs-content">
                            <Row>
                                <div className="col-md-3 col-xs-12 p-2">
                                    Book:
                                    <select id="scripturebook" className="dropdown-toggle btn btn-secondary"
                                            style={{width: "100%"}}
                                            onChange={e => this.changeBookHandlerFrom(e)}>
                                        <option key="no-selection-made" className="dropdown-item">Book ...</option>
                                        {this.getBookOptions()}
                                    </select>
                                </div>
                                <div className="col-md-2 col-xs-12 p-2">
                                    Chapter:
                                    <select id="scripturechapterfrom" disabled={this.state.isChapterDisabled}
                                            className="dropdown-toggle btn btn-secondary" style={{width: "100%"}}
                                            onChange={e => this.changeChapterHandlerFrom(e)}>
                                        <option className="dropdown-item">Chapter ...</option>
                                        {this.state.chapterOptionsFrom}
                                    </select>
                                </div>
                                <div className="col-md-2 col-xs-12 p-2">
                                    Verse from:
                                    <select id="scriptureversefrom" disabled={this.state.isVerseDisabled}
                                            className="dropdown-toggle btn btn-secondary" style={{width: "100%"}}
                                            onChange={e => this.changeVerseHandlerFrom(e)}>
                                        <option className="dropdown-item">Verse ...</option>
                                        {this.state.verseOptionsFrom}
                                    </select>
                                </div>
                                <div className="col-md-2 col-xs-12 p-2">
                                    Verse to:
                                    <select id="scriptureverseto" disabled={this.state.isVerseDisabled}
                                            className="dropdown-toggle btn btn-secondary" style={{width: "100%"}}
                                            onChange={e => this.changeVerseHandlerTo(e)}>
                                        <option className="dropdown-item">Verse ...</option>
                                        {this.state.verseOptionsTo}
                                    </select>
                                </div>
                                <div className="col-md-3 col-xs-12 p-2">
                                    <br/>
                                    <div className="btn-wrapper">
                                        <Button
                                            className="btn-icon mb-3 mb-sm-0"
                                            color="primary"
                                            onClick={() => this.addPassageToList()}
                                            disabled={!this.addButtonAvailable()}
                                            style={{width: "100%"}}
                                        >
                                            <RiAddLine/>
                                            <span className="btn-inner--text">Add</span>
                                        </Button>
                                    </div>
                                </div>
                            </Row>
                        </div>
                }
                <div className="pills-sidebar">
                    <h2 style={{fontSize: '1rem'}}>Selected passages: {this.state.chosenPassageButtons && this.state.chosenPassageButtons.length > 0 ? "(" + this.state.chosenPassageButtons.length + ")" : <></>}</h2>
                    {this.state.chosenPassageButtons?.length
                        ? <span></span>
                        : <p>No selection made</p>
                    }
                    {
                        this.state.chosenPassageButtons
                    }
                </div>
            </div>
        )
    }
};

export default withNavigationHook(ScripturesDropdown);
